/**
 * IoT Shack MQTT path honesty.
 *
 * There is no MQTT broker / topic / message-count surface on this Shack.
 * Listeners are TCP/UDP/HTTP only. Do not invent a broker or register a listener
 * to make /iotshack/mqtt look live. The old catch-all dumped this path onto
 * the dashboard — that is the lie this helper exists to stop.
 */

export const MQTT_ABSENT_TITLE = 'MQTT is not on this Shack';

export const MQTT_ABSENT_BODY =
  'This Shack has no MQTT broker, topic string, or message-count surface. ' +
  'Listeners here are TCP/UDP/HTTP only. This page does not invent a broker or register a listener.';

export function mqttAbsentCopy(): { title: string; body: string } {
  return { title: MQTT_ABSENT_TITLE, body: MQTT_ABSENT_BODY };
}

/** True for the Shack MQTT path (with or without the /iotshack prefix). */
export function isIotMqttPath(pathname: string): boolean {
  const path = String(pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  if (path === '/mqtt' || path === 'mqtt') return true;
  return /(^|\/)iotshack\/mqtt$/.test(path);
}
